import { stepGroups } from '@/features/chat/phase1/stepGroups'
import { sourcePillsFromCitations } from '@/features/chat/phase1/sourcePills'
import { isResearchCategory } from '@/features/chat/phase1/thoughtPhaseHelpers'
import NarrationText from './NarrationText'
import StepGroupRow from './StepGroupRow'
import SourcePills from './thoughtchain/SourcePills'
import ThoughtStep from './thoughtchain/ThoughtStep'

function phaseRunning(rows, streaming) {
  if (!streaming) return false
  return rows.some((row) => row.status === 'running' || row.status === 'failed')
}

export default function ActivityPhase({
  phase,
  streaming = false,
  citations = [],
  showConnector = true,
}) {
  const running = phaseRunning(phase.rows, streaming)
  const pills = isResearchCategory(phase.id)
    ? sourcePillsFromCitations(citations)
    : []
  return (
    <ThoughtStep
      category={phase.id}
      title={phase.title}
      streaming={streaming}
      running={running}
      showConnector={showConnector}
    >
      <NarrationText text={phase.narration} />
      {stepGroups(phase.rows).map((group) => (
        <StepGroupRow key={group.id} group={group} streaming={streaming} />
      ))}
      <SourcePills labels={pills} />
    </ThoughtStep>
  )
}
